/**
 * @generated SignedSource<<70d739162c61c42a4299d177ca55ed23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnalyticsTimeResolution = "DAY" | "MONTH" | "QUARTER" | "WEEK";
export type WorkspaceAnalyticsDimensionType = "STORE" | "WORKSPACE_OWNER";
export type WorkspaceAnalyticsMainQuery$variables = {
  groupByDimension?: WorkspaceAnalyticsDimensionType | null;
  timeResolution?: AnalyticsTimeResolution | null;
  workspaceId: string;
};
export type WorkspaceAnalyticsMainQuery$data = {
  readonly workspace: {
    readonly productDateTrackerCompleted: {
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
    readonly productDateTrackerRegistered: {
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
    readonly singlePeriodAnalytics: {
      readonly " $fragmentSpreads": FragmentRefs<"SinglePeriodTableTopAndBottom">;
    } | null;
    readonly taskExecutionsCompleted: {
      readonly connection: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly formattedDate: string;
          };
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
    readonly todoCreated: {
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
    readonly todoIssueCreated: {
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
    readonly todoIssueResolved: {
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
    readonly todoIssueResolvedAvgTime: {
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
    readonly todoResolved: {
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
    readonly todoTTR: {
      readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesOverviewItem_data">;
    } | null;
  };
};
export type WorkspaceAnalyticsMainQuery = {
  response: WorkspaceAnalyticsMainQuery$data;
  variables: WorkspaceAnalyticsMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupByDimension"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeResolution"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "TASK_EXECUTIONS_COMPLETED"
  }
],
v5 = {
  "kind": "Variable",
  "name": "groupByDimension",
  "variableName": "groupByDimension"
},
v6 = {
  "kind": "Variable",
  "name": "timeResolution",
  "variableName": "timeResolution"
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  },
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "skip",
    "value": 1
  },
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedDate",
  "storageKey": null
},
v9 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TimeSeriesOverviewItem_data"
},
v10 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "TODO_ISSUE_CREATED"
  }
],
v11 = [
  (v9/*: any*/)
],
v12 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "TODO_ISSUE_RESOLVED"
  }
],
v13 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "TODO_ISSUE_RESOLVED_AVG_TIME"
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "TODO_CREATED"
  }
],
v15 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "TODO_RESOLVED"
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "TODO_RESOLVED_AVG_TIME"
  }
],
v17 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "PRODUCT_DATE_TRACKER_REGISTERED"
  }
],
v18 = [
  {
    "kind": "Literal",
    "name": "metric",
    "value": "PRODUCT_DATE_TRACKER_TASKS_COMPLETED"
  }
],
v19 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avg",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "TimeSeriesAnalyticsConnection",
  "kind": "LinkedField",
  "name": "connection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeSeriesAnalyticsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSeriesAnalyticsNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueUnit",
  "storageKey": null
},
v24 = [
  (v23/*: any*/),
  (v22/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metric",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceAnalyticsMainQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            {
              "alias": "taskExecutionsCompleted",
              "args": (v4/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": (v7/*: any*/),
                  "concreteType": "TimeSeriesAnalyticsConnection",
                  "kind": "LinkedField",
                  "name": "connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TimeSeriesAnalyticsEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TimeSeriesAnalyticsNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v8/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v9/*: any*/)
              ],
              "storageKey": "analytics(metric:\"TASK_EXECUTIONS_COMPLETED\")"
            },
            {
              "alias": "todoIssueCreated",
              "args": (v10/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": "analytics(metric:\"TODO_ISSUE_CREATED\")"
            },
            {
              "alias": "todoIssueResolved",
              "args": (v12/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": "analytics(metric:\"TODO_ISSUE_RESOLVED\")"
            },
            {
              "alias": "todoIssueResolvedAvgTime",
              "args": (v13/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": "analytics(metric:\"TODO_ISSUE_RESOLVED_AVG_TIME\")"
            },
            {
              "alias": "todoCreated",
              "args": (v14/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": "analytics(metric:\"TODO_CREATED\")"
            },
            {
              "alias": "todoResolved",
              "args": (v15/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": "analytics(metric:\"TODO_RESOLVED\")"
            },
            {
              "alias": "todoTTR",
              "args": (v16/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": "analytics(metric:\"TODO_RESOLVED_AVG_TIME\")"
            },
            {
              "alias": "productDateTrackerRegistered",
              "args": (v17/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": "analytics(metric:\"PRODUCT_DATE_TRACKER_REGISTERED\")"
            },
            {
              "alias": "productDateTrackerCompleted",
              "args": (v18/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": (v11/*: any*/),
              "storageKey": "analytics(metric:\"PRODUCT_DATE_TRACKER_TASKS_COMPLETED\")"
            },
            {
              "alias": null,
              "args": (v19/*: any*/),
              "concreteType": "SinglePeriodAnalytics",
              "kind": "LinkedField",
              "name": "singlePeriodAnalytics",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SinglePeriodTableTopAndBottom"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceAnalyticsMainQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": "taskExecutionsCompleted",
            "args": (v4/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": "analytics(metric:\"TASK_EXECUTIONS_COMPLETED\")"
          },
          {
            "alias": "todoIssueCreated",
            "args": (v10/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "analytics(metric:\"TODO_ISSUE_CREATED\")"
          },
          {
            "alias": "todoIssueResolved",
            "args": (v12/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "analytics(metric:\"TODO_ISSUE_RESOLVED\")"
          },
          {
            "alias": "todoIssueResolvedAvgTime",
            "args": (v13/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "analytics(metric:\"TODO_ISSUE_RESOLVED_AVG_TIME\")"
          },
          {
            "alias": "todoCreated",
            "args": (v14/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "analytics(metric:\"TODO_CREATED\")"
          },
          {
            "alias": "todoResolved",
            "args": (v15/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "analytics(metric:\"TODO_RESOLVED\")"
          },
          {
            "alias": "todoTTR",
            "args": (v16/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "analytics(metric:\"TODO_RESOLVED_AVG_TIME\")"
          },
          {
            "alias": "productDateTrackerRegistered",
            "args": (v17/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "analytics(metric:\"PRODUCT_DATE_TRACKER_REGISTERED\")"
          },
          {
            "alias": "productDateTrackerCompleted",
            "args": (v18/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": "analytics(metric:\"PRODUCT_DATE_TRACKER_TASKS_COMPLETED\")"
          },
          {
            "alias": null,
            "args": (v19/*: any*/),
            "concreteType": "SinglePeriodAnalytics",
            "kind": "LinkedField",
            "name": "singlePeriodAnalytics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SinglePeriodAnalyticsMetric",
                "kind": "LinkedField",
                "name": "metrics",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAggregated",
                    "storageKey": null
                  },
                  (v25/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SinglePeriodAnalyticsDimension",
                "kind": "LinkedField",
                "name": "dimensions",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SinglePeriodAnalyticsDimensionMetric",
                    "kind": "LinkedField",
                    "name": "metrics",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v21/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5b3a09225258d66420b6e87851fc184a",
    "id": null,
    "metadata": {},
    "name": "WorkspaceAnalyticsMainQuery",
    "operationKind": "query",
    "text": "query WorkspaceAnalyticsMainQuery(\n  $workspaceId: ID!\n  $groupByDimension: WorkspaceAnalyticsDimensionType\n  $timeResolution: AnalyticsTimeResolution\n) {\n  workspace(id: $workspaceId) {\n    taskExecutionsCompleted: analytics(metric: TASK_EXECUTIONS_COMPLETED) {\n      connection(first: 2, skip: 1, groupByDimension: $groupByDimension, timeResolution: $timeResolution) {\n        edges {\n          node {\n            formattedDate\n          }\n        }\n      }\n      ...TimeSeriesOverviewItem_data\n    }\n    todoIssueCreated: analytics(metric: TODO_ISSUE_CREATED) {\n      ...TimeSeriesOverviewItem_data\n    }\n    todoIssueResolved: analytics(metric: TODO_ISSUE_RESOLVED) {\n      ...TimeSeriesOverviewItem_data\n    }\n    todoIssueResolvedAvgTime: analytics(metric: TODO_ISSUE_RESOLVED_AVG_TIME) {\n      ...TimeSeriesOverviewItem_data\n    }\n    todoCreated: analytics(metric: TODO_CREATED) {\n      ...TimeSeriesOverviewItem_data\n    }\n    todoResolved: analytics(metric: TODO_RESOLVED) {\n      ...TimeSeriesOverviewItem_data\n    }\n    todoTTR: analytics(metric: TODO_RESOLVED_AVG_TIME) {\n      ...TimeSeriesOverviewItem_data\n    }\n    productDateTrackerRegistered: analytics(metric: PRODUCT_DATE_TRACKER_REGISTERED) {\n      ...TimeSeriesOverviewItem_data\n    }\n    productDateTrackerCompleted: analytics(metric: PRODUCT_DATE_TRACKER_TASKS_COMPLETED) {\n      ...TimeSeriesOverviewItem_data\n    }\n    singlePeriodAnalytics(groupByDimension: $groupByDimension, timeResolution: $timeResolution) {\n      ...SinglePeriodTableTopAndBottom\n    }\n    id\n  }\n}\n\nfragment SinglePeriodTableTopAndBottom on SinglePeriodAnalytics {\n  metrics {\n    isAggregated\n    metric\n  }\n  dimensions {\n    id\n    label\n    ...SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension\n  }\n}\n\nfragment SinglePeriodTableTopAndBottomTableRow_SinglePeriodAnalyticsDimension on SinglePeriodAnalyticsDimension {\n  id\n  label\n  color\n  metrics {\n    metric\n    avg\n    total\n  }\n}\n\nfragment TimeSeriesOverviewItem_data on WorkspaceTimeSeriesAnalytics {\n  valueUnit\n  connection(first: 2, skip: 1, groupByDimension: $groupByDimension, timeResolution: $timeResolution) {\n    edges {\n      node {\n        formattedDate\n        total\n        avg\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4add2eecd5bb7ff98a3b8722c2ed99e";

export default node;
